<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading" v-if="true">
          <div class="ml-4 mt-4 mb-4">
            {{defineDocumentFromTag(this.getDetailBasic.tag).title + " Relationships"}}
          </div>
        </v-layout>
        <div v-if="getDetailLink.adid !== undefined">
          <div v-if="
          this.getDetailLink.adid !== '' &&
          this.getDetailLink.adid !== null"
          >
            <v-layout row :class="ui.textSubheading">
              <span class="ml-4 mt-4 mb-2"
              v-if="this.getDetailBasic.tag === 'A1'">
                Master Asset
              </span>
              <span class="ml-4 mt-4 mb-2" v-else>
                Asset
              </span>
            </v-layout>
            <v-layout row>
              <v-spacer/>
              <GetTreePage v-if="true"
              :data="{
                did: this.getDetailLink.adid,
                tag: 'A1.M',
                size: 'icon',
                type: null,
                item: null
                }"
              />
              <DocumentInfoCard v-if="true"
              :data="{
                btn: 'icon',
                type: 'LINK',
                cdid: null,
                fdid: null,
                did: this.getDetailLink.adid,
                tag: 'A1'}"
              />
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12>
                <v-text-field
                :label="this.getDetailLink.at"
                :prepend-icon="this.defineDocumentFromTag('A1').icon"
                :hint="(this.defineDocumentFromTag('A1').title).toLowerCase()"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="this.getDetailLink.aid"
                prepend-icon="sell"
                hint="id"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="displayDocumentIDGTypeA('A1', this.getDetailLink.aidg)"
                prepend-icon="pin"
                hint="idg"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div v-if="getDetailLink.msdid !== undefined">
          <div v-if="
          this.getDetailLink.msdid !== '' &&
          this.getDetailLink.msdid !== null"
          >
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-4 mb-2">
                Maintenance Strategy
              </div>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12>
                <v-text-field
                :label="this.getDetailLink.mst"
                :prepend-icon="this.defineDocumentFromTag('M2').icon"
                :hint="(this.defineDocumentFromTag('M2').title).toLowerCase()"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="this.getDetailLink.msid"
                prepend-icon="sell"
                hint="id"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="displayDocumentIDGTypeA('M2', this.getDetailLink.msidg)"
                prepend-icon="pin"
                hint="idg"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div v-if="getDetailLink.msdid !== undefined">
          <div v-if="
          this.getDetailLink.msdid !== '' &&
          this.getDetailLink.msdid !== null"
          >
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-4 mb-2">
                Maintenance Activity
              </div>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12>
                <v-text-field
                :label="this.getDetailLink.mat"
                :prepend-icon="this.defineDocumentFromTag('M1').icon"
                :hint="(this.defineDocumentFromTag('M1').title).toLowerCase()"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="this.getDetailLink.maid"
                prepend-icon="sell"
                hint="id"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="displayDocumentIDGTypeA('M1', this.getDetailLink.maidg)"
                prepend-icon="pin"
                hint="idg"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div v-if="getDetailLink.mpdid !== undefined">
          <div v-if="
          this.getDetailLink.mpdid !== '' &&
          this.getDetailLink.mpdid !== null"
          >
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-4 mb-2">
                Maintenance Plan
              </div>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12>
                <v-text-field
                :label="this.getDetailLink.mpt"
                :prepend-icon="this.defineDocumentFromTag('M5').icon"
                :hint="(this.defineDocumentFromTag('M5').title).toLowerCase()"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="this.getDetailLink.mpid"
                prepend-icon="sell"
                hint="id"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="displayDocumentIDGTypeA('M5', this.getDetailLink.mpidg)"
                prepend-icon="pin"
                hint="idg"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div v-if="getDetailLink.sdid !== undefined">
          <div v-if="
          this.getDetailLink.sdid !== '' &&
          this.getDetailLink.sdid !== null"
          >
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-4 mb-2">
                Source Notification
              </div>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="this.getDetailLink.st"
                prepend-icon="title"
                hint="title"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="this.getDetailLink.sid"
                prepend-icon="sell"
                hint="id"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="displayDocumentIDGTypeA(this.getDetailLink.stag, this.getDetailLink.sidg)"
                prepend-icon="pin"
                hint="did"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div v-if="getDetailLink.rdid !== undefined">
          <div v-if="
          this.getDetailLink.rdid !== '' &&
          this.getDetailLink.rdid !== null"
          >
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-4 mb-2">
                Risk Assessment
              </div>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12>
                <v-text-field
                :label="this.getDetailLink.rt"
                :prepend-icon="defineDocumentFromTag(this.getDetailLink.rtag).icon"
                :hint="(defineDocumentFromTag(this.getDetailLink.rtag).title).toLowerCase()"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="this.getDetailLink.rid"
                prepend-icon="sell"
                hint="id"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="displayDocumentIDGTypeA(this.getDetailLink.rtag, this.getDetailLink.ridg)"
                prepend-icon="pin"
                hint="gid"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div v-if="getDetailLink.pdid !== undefined">
          <div v-if="
          this.getDetailLink.pdid !== '' &&
          this.getDetailLink.pdid !== null"
          >
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-4 mb-2">
                Operational Plan
              </div>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12>
                <v-text-field
                :label="this.getDetailLink.pt"
                :prepend-icon="this.defineDocumentFromTag('B6').icon"
                :hint="(this.defineDocumentFromTag('B6').title).toLowerCase()"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="this.getDetailLink.pid"
                prepend-icon="sell"
                hint="id"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="displayDocumentIDGTypeA(this.getDetailLink.ptag, this.getDetailLink.pidg)"
                prepend-icon="pin"
                hint="did"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div v-if="getDetailLink.edid !== undefined">
          <div v-if="
          this.getDetailLink.edid !== '' &&
          this.getDetailLink.edid !== null"
          >
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-4 mb-2">
                Equipment
              </div>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12>
                <v-text-field
                :label="this.getDetailLink.et"
                :prepend-icon="this.defineDocumentFromTag('E1').icon"
                :hint="(this.defineDocumentFromTag('E1').title).toLowerCase()"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="this.getDetailLink.eid"
                prepend-icon="sell"
                hint="id"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="displayDocumentIDGTypeA(this.getDetailLink.etag, this.getDetailLink.eidg)"
                prepend-icon="pin"
                hint="did"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div v-if="getDetailLink.bdid !== undefined">
          <div v-if="
          this.getDetailLink.bdid !== '' &&
          this.getDetailLink.bdid !== null"
          >
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-4 mb-2">
                Budget Plan
              </div>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12>
                <v-text-field
                :label="this.getDetailLink.bt"
                :prepend-icon="defineDocumentFromTag(this.getDetailLink.btag).icon"
                :hint="(defineDocumentFromTag(this.getDetailLink.btag).title).toLowerCase()"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="this.getDetailLink.bid"
                prepend-icon="sell"
                hint="id"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :label="displayDocumentIDGTypeA(this.getDetailLink.btag, this.getDetailLink.bidg)"
                prepend-icon="pin"
                hint="gid"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div v-if="
        this.getDetailBasic.tag !== 'A1' &&
        this.getDetailBasic.tag !== 'F1' &&
        this.getDetailBasic.tag !== 'O1' &&
        this.getDetailLink.fdid !== undefined &&
        this.getDetailLink.fdid !== null &&
        this.getDetailLink.fdid !== ''
        ">
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4 mb-2">
              Facility Details
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12>
              <v-text-field
              :label="this.getDetailLink.ft"
              prepend-icon="place"
              hint="facility names"
              persistent-hint
              readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <!-- <v-flex xs12 md8 lg6>
              <v-text-field
              :label="this.getDetailLink.fid"
              prepend-icon="sell"
              hint="id"
              persistent-hint
              readonly
              ></v-text-field>
            </v-flex> -->
            <v-flex xs12 md8 lg6>
              <v-text-field
              :label="this.displayDocumentIDGTypeA('F1', this.getDetailLink.fidg)"
              prepend-icon="pin"
              hint="generated"
              persistent-hint
              readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div class="mt-4"/>
        <div class="ml-2 mt-4" v-if="this.enableDocumentItemEdit()">
          <div v-if="
          this.getDetailLink.fdid !== undefined &&
          this.getDetailLink.fdid !== null &&
          this.getDetailLink.fdid === ''" class="ml-3 mt-2">
          <v-layout row :class="ui.textSubheading">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> place </v-icon>
              </v-avatar>
              Add Facility if required.
            </v-chip>
          </v-layout>
          </div>
          <div v-if="
          this.getDetailChar.stat !== true &&
          this.getDetailLink.adid !== undefined &&
          this.getDetailLink.adid !== null &&
          this.getDetailLink.adid === ''" class="ml-3 mt-2">
          <v-layout row :class="ui.textSubheading">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> emoji_transportation </v-icon>
              </v-avatar>
              Add Asset if required.
            </v-chip>
          </v-layout>
          </div>
          <div v-if="
          this.getDetailChar.stat !== true &&
          this.getDetailLink.edid !== undefined &&
          this.getDetailLink.edid !== null &&
          this.getDetailLink.edid === ''" class="ml-3 mt-2">
          <v-layout row :class="ui.textSubheading">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> emoji_objects </v-icon>
              </v-avatar>
              Add Equipment Type.
            </v-chip>
          </v-layout>
          </div>
          <div v-if="
          this.getDetailLink.rdid !== undefined &&
          this.getDetailLink.rdid !== null &&
          this.getDetailLink.rdid === ''" class="ml-3 mt-2">
          <v-layout row :class="ui.textSubheading">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> emergency </v-icon>
              </v-avatar>
              Add Risk Assessment.
            </v-chip>
          </v-layout>
          </div>
          <div v-if="
          this.getDetailLink.bdid !== undefined &&
          this.getDetailLink.bdid !== null &&
          this.getDetailLink.bdid === ''" class="ml-3 mt-2">
          <v-layout row :class="ui.textSubheading">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> savings </v-icon>
              </v-avatar>
              Add Budget Process.
            </v-chip>
          </v-layout>
          </div>
          <div v-if="
          this.getDetailLink.pdid !== undefined &&
          this.getDetailLink.pdid !== null &&
          this.getDetailLink.pdid === ''" class="ml-3 mt-2">
          <v-layout row :class="ui.textSubheading">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> today </v-icon>
              </v-avatar>
              Add Operational Plan.
            </v-chip>
          </v-layout>
          </div>
        </div>
        <v-layout row class="mt-4">
        </v-layout>
        <v-layout wrap row align-right justify-end fill-height class="mt-4 ml-1"
        v-if="this.enableAppend">
          <v-spacer/>
          <AppendAssetTree :data="{tag: 'A1'}" v-if="this.getDetailLink.adid !== undefined && this.getDetailBasic.tag === 'A1'"/>
          <Append :data="{tag: 'A1'}"
          v-if="
          this.getDetailChar.stat !== true &&
          this.getDetailLink.adid !== undefined &&
          this.getDetailBasic.tag !== 'A1' &&
          this.getDetailBasic.tag !== 'W2' &&
          this.getDetailBasic.tag !== 'B3'
          "/>
          <Append :data="{tag: 'B1'}" v-if="this.getDetailLink.rdid !== undefined"/>
          <Append :data="{tag: 'B4'}"
          v-if="
          this.getDetailLink.bdid !== undefined &&
          this.getDetailBasic.tag !== 'O1' &&
          this.getDetailBasic.tag !== 'Q1' &&
          this.enableAppend === true"
          />
          <Append :data="{tag: 'B6'}"
          v-if="
          this.getDetailLink.pdid !== undefined &&
          this.getDetailBasic.tag !== 'O1' &&
          this.enableAppend === true
          "/>
          <Append :data="{tag: 'E1'}"
          v-if="
          this.getDetailChar.stat !== true &&
          this.getDetailLink.edid !== undefined"/>
          <Append :data="{tag: 'F1'}"
          v-if="
          this.getDetailChar.stat !== true &&
          this.getDetailLink.fdid !== undefined &&
          this.getDetailBasic.tag !== 'O1' &&
          this.getDetailBasic.tag !== 'Q1' &&
          this.getDetailBasic.tag !== 'B3'
          "/>
        </v-layout>
        <v-layout wrap justify-end row v-if="
        this.enableDocumentItemEdit() &&
        getUser.pref.select.cdid !== null &&
        getUser.pref.select.cdid !== undefined
        ">
          <v-spacer/>
          <DocumentInfoCard
          v-if="
          this.getDetailLink.sdid !== undefined &&
          this.getDetailLink.stag !== '' &&
          this.enableGenericDocumentInfoCard"
          :data="{
            btn: 'flat',
            type: 'LINK',
            did: this.getDetailLink.sdid,
            tag: this.getDetailLink.stag}"
          />
          <v-btn :color="ui.colorWarning" flat dark
          v-if="!this.enableGenericDocumentInfoCard">
            <v-icon left>
              place
            </v-icon>
            User/Action Facility are Not the Same.
          </v-btn>
          <!-- <DocumentInfoCard
          v-if="
          getDetailLink.rdid !== undefined &&
          getDetailLink.rdid !== null &&
          getDetailLink.rdid !== ''
          "
          :data="{
            btn: 'flat',
            type: 'LINK',
            cdid: this.getUser.pref.select.cdid,
            fdid: null,
            did: getDetailLink.rdid,
            tag: getDetailLink.rtag}"
          /> -->
          <DocumentInfoCard
          :disabled="getDetailLink.fdid === this.getUser.pref.select.fdid"
          v-if="
          getDetailLink.adid !== undefined &&
          getDetailLink.adid !== null &&
          getDetailLink.adid !== '' &&
          getDetailLink.fdid === this.getUser.pref.select.fdid"
          :data="{
            btn: 'flat',
            type: 'LINK',
            cdid: this.getUser.pref.select.cdid,
            fdid: null,
            did: getDetailLink.adid,
            tag: getDetailLink.atag}"
          />
          <v-btn :color="ui.colorWarning" flat dark
          v-if="
          this.getDetailLink.fdid !== null &&
          this.getDetailLink.fdid !== undefined &&
          this.getDetailLink.fdid !== '' &&
          this.getDetailLink.fdid !== this.getUser.pref.select.fdid">
            <v-icon left>
              place
            </v-icon>
            Select Facility {{getDetailLink.ft}}
          </v-btn>
          <DocumentInfoCard
          v-if="
          getDetailLink.msdid !== undefined &&
          getDetailLink.msdid !== null &&
          getDetailLink.msdid !== ''"
          :data="{
            btn: 'flat',
            type: 'LINK',
            cdid: this.getUser.pref.select.cdid,
            fdid: null,
            did: getDetailLink.msdid,
            tag: 'M2'}"
          />
          <DocumentInfoCard
          v-if="
          getDetailLink.mpdid !== undefined &&
          getDetailLink.mpdid !== null &&
          getDetailLink.mpdid !== ''"
          :data="{
            btn: 'flat',
            type: 'LINK',
            cdid: this.getUser.pref.select.cdid,
            fdid: this.getUser.pref.select.fdid,
            did: getDetailLink.mpdid,
            tag: 'M5'}"
          />
          <DocumentInfoCard
          v-if="
          getDetailLink.msdid !== undefined &&
          getDetailLink.msdid !== null &&
          getDetailLink.msdid !== ''"
          :data="{
            btn: 'flat',
            type: 'LINK',
            cdid: this.getUser.pref.select.cdid,
            fdid: null,
            did: getDetailLink.msdid,
            tag: getDetailLink.mstag}"
          />
          <DocumentInfoCard
          v-if="
          getDetailLink.bdid !== undefined &&
          getDetailLink.bdid !== null &&
          getDetailLink.bdid !== ''
          "
          :data="{
            btn: 'flat',
            type: 'LINK',
            cdid: this.getUser.pref.select.cdid,
            fdid: null,
            did: getDetailLink.bdid,
            tag: getDetailLink.btag}"
          />
          <DocumentInfoCard
          v-if="
          getDetailLink.pdid !== undefined &&
          getDetailLink.pdid !== null &&
          getDetailLink.pdid !== ''
          "
          :data="{
            btn: 'flat',
            type: 'LINK',
            cdid: this.getUser.pref.select.cdid,
            fdid: null,
            did: getDetailLink.pdid,
            tag: getDetailLink.ptag}"
          />
          <DocumentInfoCard
          v-if="
          getDetailLink.edid !== undefined &&
          getDetailLink.edid !== null &&
          getDetailLink.edid !== ''
          "
          :data="{
            btn: 'flat',
            type: 'LINK',
            cdid: this.getUser.pref.select.cdid,
            fdid: null,
            did: getDetailLink.edid,
            tag: getDetailLink.etag}"
          />
          <GetRegisterListPage
          v-if="this.getDetailBasic.tag === 'B4'"
          :data="{tag: 'K6', tagd: 'B4.Q1', tags: 'B4.Q1'}"/>
          <GetRegisterListPage
          v-if="this.getDetailBasic.tag === 'B6'"
          :data="{tag: 'K6', tagd: 'B6.W', tags: 'B6.W'}"/>
        </v-layout>
        <v-layout row class="mr-1" v-if="true">
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
          v-if="getDetailLink.adid !== undefined">
            <v-icon> {{this.defineDocumentFromTag("A1").icon}} </v-icon>
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
          v-if="getDetailLink.edid !== undefined">
            <v-icon> {{this.defineDocumentFromTag("E1").icon}} </v-icon>
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
          v-if="getDetailLink.rdid !== undefined">
            <v-icon> {{this.defineDocumentFromTag("B1").icon}} </v-icon>
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
          v-if="getDetailLink.bdid !== undefined">
            <v-icon> {{this.defineDocumentFromTag("B4").icon}} </v-icon>
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
          v-if="getDetailLink.pdid !== undefined">
            <v-icon> {{this.defineDocumentFromTag("B6").icon}} </v-icon>
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
          v-if="getDetailLink.sdid !== undefined">
            <v-icon> adjust </v-icon>
          </v-chip>
        </v-layout>
        <div v-if="
        this.getPlanDID !== null &&
        this.getPlanDID !== undefined &&
        this.getDetailLink.pdid !== null &&
        this.getDetailLink.pdid !== undefined
        ">
          <v-layout row class="mr-1 mt-2" v-if="this.getDetailLink.pdid !== ''">
            <v-spacer/>
            <AppendToMaster
            v-if="
            this.getDetailBasic.tag === 'W1' ||
            this.getDetailBasic.tag === 'W2'"
            :data="{size: 'flat', detail: this.getDetail}"/>
          </v-layout>
        </div>
        <div v-if="
        this.getPlanDID !== null &&
        this.getPlanDID !== undefined &&
        this.getDetailLink.pdid !== null &&
        this.getDetailLink.pdid !== undefined
        ">
          <v-layout row class="mr-1 mt-2" v-if="this.getDetailLink.pdid !== ''">
            <v-spacer/>
            <RemoveFromMaster
            v-if="
            this.getDetailBasic.tag === 'W1' ||
            this.getDetailBasic.tag === 'W2'"
            :data="{size: 'flat', detail: this.getDetail}"/>
          </v-layout>
        </div>
        <div v-if="this.getDetailBasic.tag === 'M5'">
          <v-layout row class="mt-2">
            <v-spacer/>
            <GetRegisterListPage
            :data="{tag: 'K6', tagd: 'M7', tags: 'M7'}"
            />
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import Append from "@/data/append/components/Append";
import AppendAssetTree from "@/data/append/components/AppendAssetTree";
import describeDocument from "@/data/describe/mixins/describeDocument.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import DocumentInfoCard from "@/document/info/components/DocumentInfoCard";
import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import AppendToMaster from "@/data/append/components/AppendToMaster";
import RemoveFromMaster from "@/data/append/components/RemoveFromMaster";
import GetTreePage from "@/asset/tree/components/GetTreePage";
import documentFunctions from "@/data/functions/mixins/documentFunctions.js";
import { mapGetters } from "vuex";
export default {
  components: {
    Append,
    AppendAssetTree,
    AppendToMaster,
    RemoveFromMaster,
    DocumentInfoCard,
    GetRegisterListPage,
    GetTreePage
  },
  data() {
    return {
      valid: true
    };
  },
  mixins: [apptheme, describeDocument, displayFunctions, documentFunctions],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getDetailLink",
      "getPlanDID",
      "getTransitions",
      "getUser"
    ]),
    enableAppend() {
      let logic = null;
      let arch = this.getDetailBasic.ver;
      let status = null;
      if (this.getTransitions !== null && this.getTransitions !== undefined) {
        let flow = this.getTransitions.flow;
        status = flow[flow.length - 1].title;
      }
      // CHECK
      if (arch === "A" && arch !== undefined && arch !== null) {
        logic = false;
      } else if (status === "Closed" || status === "Cancelled") {
        logic = false;
      } else if (this.getDetailBasic.tag === "M7") {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    enableGenericDocumentInfoCard() {
      let logic = null;
      let tag = this.getDetailBasic.tag;
      // let stag = this.getDetailLink.stag;
      if (tag === "B3") {
        if (this.getUser.pref.select.fdid === this.getDetailLink.fdid) {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = true;
      }
      return logic;
    }
  }
};
</script>
